
import {Options, Vue} from 'vue-class-component';
import Popper from 'vue3-popper';
import AppointmentService from "@/services/AppointmentService";
import {RecordIdentifier} from "@/data/global";
import {Appointment} from "@/data/appointments";
import {formatDatetimeWithDayLabel, formatDateWithDayLabel, formatTime} from "@/utils/helpers";
import AppointmentEnrollmentStatus from "@/components/AppointmentEnrollmentStatus.vue";
import RegionCourses from "@/components/RegionCourses.vue";


@Options({
    props: {
        appointmentId: {
            type: Number,
            required: true,
        }
    },
    components: {
        Popper,
        AppointmentEnrollmentStatus,
        RegionCourses,
    },
    methods: {
        formatDatetimeWithDayLabel,
        formatDateWithDayLabel,
        formatTime,
    },
    emits: [
        'enrollmentStatusChange',
    ]
})
export default class AppointmentDetailModal extends Vue {

    appointmentId!: number
    loading = true
    appointmentLocal: Appointment | null = null

    currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    })

    loadAppointment(appointmentId: number) {
        this.loading = true;
        return AppointmentService.getOpenAppointment(appointmentId).then(result => {
            this.appointmentLocal = result.data.data as Appointment;
        }).finally(() => this.loading = false);
    }

    onEnrollmentStatusChange() {
        this.$emit('enrollmentStatusChange');
    }

    get description() {
        return /*this.course?.info_text ||*/ this.appointmentLocal?.course?.course_type.description || null;
    }

    get descriptionLines() {
        if (!this.description) {
            return [];
        }

        return this.description.split("\n");
    }

    mounted() {
        // Access the appointment ID from the URL params

        if (this.appointmentId) {
            this.loadAppointment(this.appointmentId); // Load the appointment based on the ID
        }
    }
}
